import styled from 'styled-components';

const Icon = styled.img`
  width: 35px;
  height: 35px;
  margin-right: 20px;

  :hover {
    cursor: pointer;
  }
`;

Icon.displayName = 'Icon';

export default Icon;
